import { Component, EventEmitter, HostListener, Input, OnDestroy, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent, SearchComponent } from '@wms/components';
import { FormsModule } from '@angular/forms';
import {ApisService, RouterHistoryService, ProjectService, DialogService} from '@wms/services';
import { Router, RouterModule } from '@angular/router';
import { WmsFeatureDirective } from '@wms/directives';
import { ApiSettingsComponent } from '../api-settings/api-settings.component';
import { WmsWorkspaceManagerService } from "@wms/workspace";
import { WmsDialogComponent, WmsDialogHeaderComponent, WmsDialogBodyComponent, WmsDialogFooterComponent } from '@wms/components';
import {
  WmsUnsavedChangesDialogComponent
} from "@wms/app/wms-unsaved-changes-dialog/wms-unsaved-changes-dialog.component";
import { find } from 'lodash-es';
import { replace } from 'projects/core/src/utils/utils';
import { ImportApiComponent } from "../import-api/import-api.component";
import {setLocalStorageItem} from "../../../../../projects/core/src/utils/studio-user-preferences";
import {MixpanelService} from "@wms/app/services/mixpanel/mixpanel.service";
import {ApiWorkspaceService} from "@wms/app/api-workspace.service";
@Component({
  standalone: true,
  selector: 'wms-api-designer',
  templateUrl: './api-designer.component.html',
  styleUrls: ['./api-designer.component.less'],
  imports: [ApiSettingsComponent, CommonModule, FormsModule, RouterModule, SearchComponent, WmsFeatureDirective, WmsDialogHeaderComponent, WmsDialogBodyComponent, WmsDialogFooterComponent, WmsDialogComponent, WmsUnsavedChangesDialogComponent, ImportApiComponent]
})

export class ApiDesignerComponent extends BaseComponent implements OnDestroy {
  public swaggerJson: any;
  ctrlOptions: any;
  project: any;

  serviceTypeConstants: any;
  services: any;
  currentService: any;
  @Input() hideResources: boolean;
  disableSearch: boolean = true;
  hideActions: boolean = true;
  apiWsService:ApiWorkspaceService;
  private wsManager: WmsWorkspaceManagerService;
  private dialogParams: any = {};
  modalName: 'reImportApi' | 'ImportApi' = 'reImportApi';
  showGuidedTourSubscription: any;
  @Output() toggleResources: EventEmitter<string> = new EventEmitter()

  @HostListener('click', ['$event.target'])
  onClick($event: any) {
    if ($event.id !== 'api_designer_settings') {
      this.apiService.isSettingsApi = false;
    }
  }
  constructor(public apiService: ApisService, private router: Router, private routerHistoryService: RouterHistoryService, private dialogService: DialogService,
              private mixpanelService: MixpanelService) {
    super();
    this.ctrlOptions = this.apiService.ctrlOptions;
    this.serviceTypeConstants = this.apiService.serviceTypeConstants;
    this.services = this.apiService.services;
    this.currentService = this.apiService.currentService;
    this.project = this.preferences.project;
    this.apiWsService = inject(ApiWorkspaceService);
    this.wsManager = inject(WmsWorkspaceManagerService);
    this.registerDestroyListener.add(this.eventManager.saveApiWSObservable().subscribe((successCb: Function) => {
      this.dialogParams['cb'] = successCb;
      if (this.wsManager.triggerSaveImmediately) {
        this.invokeSaveFn();
      }
    }));
    this.showGuidedTourSubscription = this.eventManager.showGuidedTourObservable().subscribe((value: boolean) => this.apiWsService.showGuidedTour = value);
  }


  getInnerHtml(obj: any) {
    if (obj) {
      return obj[this.apiService.RELATIVE_PATH_KEY] || obj['relativePath'];
    }
  }

/* <<<<<<<<<<<<<<  ✨ Windsurf Command ⭐ >>>>>>>>>>>>>>>> */
  /**
   * Returns the base path key for the given active API.
   * If the active API is truthy, returns a string in the format `/serviceId`, otherwise returns an empty string.
   * @param {any} activeApi - The active API.
   * @returns {string} - The base path key.
   */
/* <<<<<<<<<<  cb35d21a-2346-4bf7-89af-8bf47368601b  >>>>>>>>>>> */
  getBasePathKey(activeApi: any) {
    return activeApi ? `/${activeApi.serviceId}` : '';
  }




  getcurrent() {
    return this.apiService.currentService;
  }






  setActiveApi($event: any, api: any, forceReload: boolean, forceSetApi?: boolean, loadSwagger?: boolean) {
    const targetAPI = {node : false, api, forceReload, loadSwagger}
    if(this.apiService.saveCurrentApiIfDirty(targetAPI)){
      $event?.stopPropagation();
      return
    }
    // return if the controller is already selected.
    if (!forceSetApi && (!api || api.controllerName === this.apiService.activeApi.controllerName)) {
      return;
    }
    // clear active tag on click of other endpoint
    if (this.apiService.activeApiHead) {
      this.apiService.activeApiHead.api.activeTag = null;
    }
    this.apiService._setActiveApi(api, forceReload, loadSwagger);
  }

  getDStitle() {
    return this.currentService?.open ? this.locale['LABEL_COLLAPSE'] : this.locale['LABEL_EXPAND'];
  }

  getAPISaveDialogDescription(){
    let activeAPIName = '';
    if(this.apiService.activeServiceType === 'OpenAPIService'){
      const dirtyAPI = find(this.apiService.currentService?.filteredApis, {isActive : true})
      activeAPIName = this.getInnerHtml(dirtyAPI)
    }else{
      const dirtyAPI = this.apiService.filteredServices?.find((service : any)=> service.apis && service.apis[0].isActive)?.apis[0]
      activeAPIName = this.getInnerHtml(dirtyAPI)
    }
    return replace(this.locale.MESSAGE_API_DESIGNER_SAVE_CHANGES, [activeAPIName]) as string
  }

  saveChanges(closeModal?: boolean) {
    return this.invokeSaveFn().then(()=>{
      this.moveToTargetURL(closeModal)
    })
  }

  resetChanges(closeModal?: boolean){
    this.dialogParams.cb && this.dialogParams.cb();
    this.dialogParams.cb = null;
    this.wsManager.setDirtyonWs(false)
    this.moveToTargetURL(closeModal)
  }

  moveToTargetURL(closeModal?: boolean){
    if(this.apiService.nextState?.url) {
      this.router.navigateByUrl(this.apiService.nextState.url);
    }
    closeModal && this.closeModal()
    const targetAPI = this.apiService.apiToLoadNext
    if(targetAPI) {
      targetAPI.node ?
        this.apiService._generateAPINodeClick.next(targetAPI.api)
        :
        this.setActiveApi(undefined, targetAPI.api, targetAPI.forceReload, undefined, targetAPI.loadSwagger);
        this.apiService.apiToLoadNext = null
    }
  }

  invokeSaveFn(){
   return this.apiWsService.updateApi(false).then(() => {
      this.dialogParams.cb && this.dialogParams.cb();
      this.dialogParams.cb = null;
    }).catch(() =>{
      if(this.wsManager.isWSDirty() && this.wsManager.triggerSaveImmediately){
        this.dialogService.open('unsavedChangesDialog_api')
      }
    })
  }

  closeModal(){
    this.dialogService.close('unsavedChangesDialog_api')
    if(this.apiService.nextState?.url) {
      this.apiService.nextState = null;
    }
    this.dialogParams.cb = null;
  }

  openDialogWithId(id: string): void {
    this.dialogService.open(id)
  }
  closeDialogWithId(id: string): void {
    this.dialogService.close(id);
  }



  getOpenApiServices(reloadFlag: boolean, swagger: any) {
    this.apiService._refreshApiService.next({reloadFlag: reloadFlag, swagger: swagger});
  }



  override ngOnDestroy() {
    super.ngOnDestroy();
    if(this.showGuidedTourSubscription)
      this.showGuidedTourSubscription.unsubscribe();
  }
}
